import { createContext } from 'react';
import type { ProjectFilterContextValue } from './projectTypes';

export const ProjectFilterContext = createContext<ProjectFilterContextValue | undefined>(undefined);
